<template>
  <div class="div">
    <img src="https://homeimage.ksaxshop.com/tou.png" alt="" class="w100">
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {

} from "../../api/api";

export default {
  components: {},
  created() {

  },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped>
.div {
  background: #E9F2FB;
  min-height: 100%;
  padding-bottom: 50px;
}

img {
  display: block;
}

.main {
  background-color: #fff;
  width: 80%;
  margin: 0 auto;
  margin-top: -20%;
  border-radius: 24px;
  padding: 24px;
  position: relative;
}
</style>
